import React from 'react';
import { Link } from 'react-router-dom';
import DumpsterCarousel from './DumpsterCarousel';
import './Home.css';

function Home() {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="container">
            <h1>Professional Dumpster Rental Services</h1>
            <p>Reliable waste management solutions for your projects</p>
            {/* <Link to="/booking" className="cta-button">Get Your Quote Today</Link> */}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose All Star Logistics?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <i className="fas fa-truck-fast"></i>
              <h3>Fast Delivery</h3>
              <p>Same-day or next-day delivery available for most locations</p>
            </div>
            <div className="feature-card">
              <i className="fas fa-clock"></i>
              <h3>Flexible Rental Periods</h3>
              <p>Short-term and long-term rentals to suit your timeline</p>
            </div>
            <div className="feature-card">
              <i className="fas fa-dollar-sign"></i>
              <h3>Competitive Pricing</h3>
              <p>Transparent pricing with no hidden fees</p>
            </div>
            <div className="feature-card">
              <i className="fas fa-recycle"></i>
              <h3>Eco-Friendly</h3>
              <p>Responsible waste management and recycling practices</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Pricing Section */}
      {/* Short Term Pricing- 350 dollars for 5 days, extra days charged at $25/day. Two ton limit with a $50/ton overweight fee. */}
      <section className="pricing-section">
        <div className="container">
          <h2>Transparent Pricing</h2>
          <div className="price-cards">
            <div className="price-card">
              <h4>Short Term Pricing</h4>
              <p className="price">$350 for 5 days</p>
              <p className="duration">+ $25 each additional day for up to 5 days</p>
              <ul className="price-features">
                <li>Two ton limit with a $50/ton overweight fee</li>
                <li><i className="fas fa-truck"></i> Delivery included</li>
                <li><i className="fas fa-undo"></i> Pickup included</li>
              </ul>
            </div>
            {/* <div className="price-card featured">
              <h4>Long-Term Rental</h4>
              <p className="price">$595</p>
              <p className="duration">10 days</p>
              <ul className="price-features">
                <li><i className="fas fa-truck"></i> Delivery included</li>
                <li><i className="fas fa-undo"></i> Pickup included</li> <br></br>
                <li>For 10+ days, please contact us at</li>
                <li><a href="tel:+12563666679" className="contact-link">(256) 366-6679</a> </li> 
                <li>or email </li>
                <li><a href="mailto:sales@allstarrecycling.net" className="contact-link">sales@allstarrecycling.net</a></li>
             
              </ul>
            </div> */}
            {/* Long Term Pricing- Ask for Quote here */}


            <div className="price-card">
              <h4>Long Term Pricing</h4>
              <p className="price">Ask for Quote</p>
              <ul className="price-features">
                <Link to="/booking" className="quote-button">Get a Quote</Link>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section
      <section className="services-cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Get your dumpster rental quote today and experience our exceptional service.</p>
          <Link to="/booking" className="cta-button">Request a Quote</Link>
        </div>
      </section> */}

      {/* Equipment Section */}
      <section className="equipment">
        <div className="container">
          <h2 className="section-title">Our Equipment</h2>
          <p className="section-description">
            View our range of well-maintained 30-yard dumpsters
          </p>
          <DumpsterCarousel />
        </div>
      </section>
    </div>
  );
}

export default Home;
